/* eslint-disable max-len */
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { Autocomplete, TextField } from '@mui/material';
import ListboxComponent from 'Shared/Header/AdapaterReactWindow';
import useForm from 'Shared/Hooks/hooks/useForm';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import axios from 'axios';
import { toast } from 'react-toastify';
import Trace from './Trace';
import { defaultMessage, getAllDocuments, getDocumentAchatsChange } from '../TraceabilityServices';
import PageActions from './PageActions';
import { setLoadingTrace } from '../traceabilitySlice';
import { PopperMy } from '../constants';

let cancelToken;
const DocummentAchatTrace = () => {
  const [isLast, setIsLast] = useState(false);
  const [page, setPage] = useState(0);
  const [traces, setTraces] = useState([]);
  const [shadows, setShadows] = useState([]);
  const [parentTraces, setParentTraces] = useState([]);
  const dispatch = useDispatch();
  const { values, onChange } = useForm({ search: null, searchInput: '' });

  const [documentPage, setDocumentPage] = useState({ content: [] });
  const [loading, setLoading] = useState(false);
  const handleChange = (propery) => (e, value) => {
    onChange({ target: { name: propery, value } });
  };
  useEffect(async () => {
    try {
      dispatch(setLoadingTrace());
      const {
        changes, parents, page: currentPage, shadows: list,
      } = await getDocumentAchatsChange({
        page, id: values.search?.id,
      });
      setShadows(list);
      if (changes.length === 0) {
        setIsLast(true);
      } else {
        setIsLast(false);
        setTraces(changes);
        setPage(currentPage);
        setParentTraces(parents);
      }
    } catch (error) {
      if (error.message === 'not found') {
        setTraces([]);
      }
    } finally {
      dispatch(setLoadingTrace());
    }
  }, [page, values.search, setShadows]);

  const getDocumentPage = useCallback(
    async () => {
      if (values.searchInput === '') {
        return;
      }
      setLoading(true);
      try {
        if (typeof cancelToken !== typeof undefined) {
          cancelToken.cancel('Cancel');
        }
        cancelToken = axios.CancelToken.source();
        const data = await getAllDocuments(
          { size: 30, page: 0 }, { search: values.searchInput }, { cancelToken: cancelToken.token },
        );
        setDocumentPage(data);
      } catch (e) {
        if (e.message !== 'Cancel') {
          const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
          toast.error(statusLabel);
        }
      } finally {
        setLoading(false);
      }
    },
    [values.searchInput],
  );

  useEffect(() => {
    getDocumentPage();
  }, [getDocumentPage]);
  const lines = useMemo(() => Object.entries(shadows).map(([key, value]) => ({
    id: key, property: value,
  })), [shadows]);
  return (
    <>
      {loading && <GlobalLoader size="100vh" />}

      <Autocomplete
        PopperComponent={PopperMy}
        // classes={{ root: classes.filter }}
        options={documentPage?.content || []}
        onChange={handleChange('search')}
        disablePortal
        value={values.search}
        size="small"
        onClick={(e) => { e.stopPropagation(); }}
        autoHighlight
        getOptionLabel={(option) => option.folderCode}
        ListboxComponent={ListboxComponent}
        filterOptions={(options, v) => options
          .filter((option) => option.folderCode
            ?.toLowerCase().includes(v.inputValue.toLowerCase()))}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Rechercher"
            variant="outlined"
            name="searchInput"
            onChange={onChange}
            value={values.searchInput}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
          />
        )}
        popupIcon={<ExpandMoreIcon style={{ color: '#000' }} />}
      />
      <PageActions page={page} setPage={setPage} isLast={isLast} />
      {traces.map((trace) => (
        <Trace
          key={`key-trace-card-${trace.commitMetadata.id}`}
          changes={trace.changes}
          parents={parentTraces}
          commitMetadata={trace.commitMetadata}
          lines={lines}
          isDoc
        />
      ))}
    </>
  );
};

export default DocummentAchatTrace;
